import style from './ForgotPassword.module.scss';
import { Button, Form, FormAlert, FormField, FormGroup } from '@ax/ui';
import { routerPaths } from '@ax/constants';
import { Link } from 'react-router-dom';
import { FieldError, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ForgotPasswordFormInputSchema } from './ForgotPasswordFormInputSchema';
import { RequestPasswordRequestApiParams } from '@ax/service/src/signup-interface';
import { useRequestPasswordResetApi } from '@/hooks/api';
import { useEffect, useState } from 'react';

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(ForgotPasswordFormInputSchema),
    mode: 'onSubmit',
  });

  const [email, setEmail] = useState('');

  const handleFormSubmit = async (data: RequestPasswordRequestApiParams) => {
    try {
      setEmail(data.email || '');
    } catch (err) {
      console.error(err);
    }
  };

  const {
    data: passwordResetResponse,
    isLoading,
    isError,
    error,
  }: any = useRequestPasswordResetApi(email);

  useEffect(() => {
    if (isError) {
      reset();
    }
  }, [isError, error]);

  return (
    <div className={style.page__container}>
      <div className={style.form__container}>
        <div className={style.form__header}>
          <div className={style.form__header__title}>Password Reset</div>
        </div>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <FormAlert
            message={error ? error?.response?.data?.message : passwordResetResponse?.message}
            type={error ? 'error' : 'success'}
          />
          {!passwordResetResponse?.success && (
            <>
              <FormGroup className="mb-[20px]">
                <FormField error={errors.email as FieldError}>
                  <input
                    type="email"
                    className="input"
                    placeholder="Enter email address"
                    {...register('email')}
                  />
                </FormField>
              </FormGroup>
              <Button
                className="h-[40px] mr-[20px]"
                variant="primary"
              >
                {isLoading ? 'Processing...' : 'Reset'}
              </Button>
            </>
          )}
          <Link
            to={routerPaths.login}
            className={style.form__link}
          >
            Back to Sign In
          </Link>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
